import {SagaIterator} from "redux-saga";
import Api, {ApiError} from "modules/utils/Api";
import {call, put} from "typed-redux-saga";
import {
	checkUserNameFailed,
	checkUserNameSuccess,
	retrieveUserSuccess,
	sendThanksForPlayingViewedSuccess,
	setSessionState,
	showErrorModal,
} from "modules/actions";
import {RequestState} from "modules/enums";
import {IBackdoorPayload, ISagaAction, IUserLoginPayload} from "modules/types";

export const processSessionSaga = function* (): SagaIterator {
	try {
		yield* put(setSessionState(RequestState.Requested));
		const result = yield* call(Api.User.session);
		yield* put(retrieveUserSuccess(result.data.success));
	} catch (e) {
		console.log(e);
	} finally {
		yield* put(setSessionState(RequestState.Received));
	}
};

export const checkUserNameSaga = function* ({
	payload,
}: ISagaAction<Pick<IUserLoginPayload, "uid">>): SagaIterator {
	try {
		const result = yield* call(Api.User.check_username, payload.uid);
		ApiError.CHECK(result.data);

		yield* put(checkUserNameSuccess(result.data.success));
	} catch (e) {
		yield* put(checkUserNameFailed());
		const error = e as ApiError;
		yield* put(showErrorModal(error.message));
	}
};

export const processLoginSaga = function* ({
	payload,
}: ISagaAction<IUserLoginPayload>): SagaIterator {
	try {
		const result = yield* call(Api.Auth.login, payload);
		ApiError.CHECK(result.data);

		yield* put(retrieveUserSuccess(result.data.success));
	} catch (e) {
		const error = e as ApiError;
		yield* put(showErrorModal(error.message));
	}
};

export const loginBackdoorSaga = function* ({
	payload,
}: ISagaAction<IBackdoorPayload>): SagaIterator {
	try {
		const response = yield* call(Api.Auth.backdoor, payload);
		ApiError.CHECK(response.data);
		yield* put(retrieveUserSuccess(response.data.success));
		// window.location.href = BASE_URL;
	} catch (e) {
		const error = e as ApiError;
		yield* put(showErrorModal(error.message));
	}
};

export const setWhatsNewModalViewedSaga = function* (): SagaIterator {
	try {
		const response = yield* call(Api.User.sendWhatsNewModalViewed);
		ApiError.CHECK(response.data);
	} catch (e) {
		const error = e as ApiError;
		yield* put(showErrorModal(error.message));
	}
};

export const setTutorialModalViewedSaga = function* (): SagaIterator {
	try {
		const response = yield* call(Api.User.sendTutorialModalViewed);
		ApiError.CHECK(response.data);
	} catch (e) {
		const error = e as ApiError;
		yield* put(showErrorModal(error.message));
	}
};

export const sendThanksForPlayingViewedSaga = function* (): SagaIterator {
	try {
		const response = yield* call(Api.User.sendThanksForPlayingViewed);
		ApiError.CHECK(response.data);
		yield* put(sendThanksForPlayingViewedSuccess());
	} catch (e) {
		const error = e as ApiError;
		yield* put(showErrorModal(error.message));
	}
};
